export const nativeToString = Object.prototype.toString;

export const isObject = (obj: any) => nativeToString.call(obj) === '[object Object]';

export const FROM_INFO_SESSION_KEY = 'web_tools_from_session_key';

/**
 * URLSearchParams
 * @param path {string}
 * @param query {object | undefined}
 */
export function mergePathQuery(path: string, query: Record<string, string> | undefined) {
  let res = path;
  if (!path.startsWith('http')) {
    const root = window.location.origin;
    if (path.startsWith('/')) {
      res = `${root}${path}`;
    } else {
      res = `${root}/${path}`;
    }
  }
  if (query && isObject(query)) {
    const searchParams = new URLSearchParams(query);
    searchParams.forEach((value, key) => {
      if (res.includes('?')) {
        res += `&${key}=${encodeURIComponent(value)}`;
      } else {
        res += `?${key}=${encodeURIComponent(value)}`;
      }
    });
  }
  return res;
}

function getFromInfoFromSession() {
  let searchParamsObject;
  const session = sessionStorage.getItem(FROM_INFO_SESSION_KEY) || '';
  try {
    searchParamsObject = JSON.parse(session);
  } catch (e: any) {
    e.message = '';
  }
  return searchParamsObject;
}

/**
 * 当前页面URL信息转from_query数据
 * 以`from_`开头的search为上一个页面的信息
 * @return {{from_pathname: string, from_origin: string, from_fromSource: ?string}}
 */
export function getPageFromQuery() {
  const url = new URL(window.location.href);
  const [, website] = url.origin.split('://');
  const from = {
    from_origin: website,
    from_pathname: url.pathname,
    from_fromSource:
      url.searchParams.get('fromSource') || url.searchParams.get('from_fromSource') || '',
  };
  if (!from.from_fromSource) {
    const session = getFromInfoFromSession();
    if (session) {
      from.from_fromSource = session.from_fromSource;
    }
  }
  return from;
}

/**
 * 打开新tab页面，url携带来源数据
 * @param path {string}
 * @param query {object}
 * @param beforeFunction {Promise<void> | undefined}
 */
export function openPage(path: string, query = {}, beforeFunction = undefined) {
  const from = getPageFromQuery();
  sessionStorage.setItem(FROM_INFO_SESSION_KEY, JSON.stringify(from));
  const target: { fromSource?: string } = {};
  if (from.from_fromSource) {
    target.fromSource = from.from_fromSource;
  }
  let href = mergePathQuery(path, Object.assign(target, query));
  try {
    const { host } = new URL(href);
    if (host !== location.host) {
      href = mergePathQuery(href, from);
    }
  } catch (e) {
    console.warn(e);
  }
  if (beforeFunction) {
    Promise.resolve(beforeFunction).then(() => {
      window.open(href);
    });
  } else {
    window.open(href);
  }
}

export const btnClick = (value: string, open: boolean) => {
  if (open) {
    window.open(value);
  } else {
    window.location.href = value;
  }
};
